import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ClearAll } from 'autogen/translation-keys/trans-website-filter';
import { Button } from 'components/Button';
import { closeAllDrawers } from 'components/generic/Drawer/hooks/useDrawer';
import useFilters from '../../../shared/hooks/useFilters';
import { FilterMenuDataContext } from '../../Filters/FilterMenuRenderer';

export default function ResetFiltersButton() {
    const { removeFiltersByQueryStrings, removeAllPendingFilters } = useFilters();

    const {
        productList: { activeFilterValues }
    } = useContext(FilterMenuDataContext);

    const handleResetFilters = () => {
        const queryStrings = activeFilterValues.map((activeFilter) => activeFilter.queryStringName);
        removeFiltersByQueryStrings(queryStrings);
        removeAllPendingFilters();
        closeAllDrawers();
    };
    const { t } = useTranslation();
    return (
        <Button size="lg" variant="secondary" onClick={handleResetFilters}>
            {t(ClearAll)}
        </Button>
    );
}
